import { render, staticRenderFns } from "./EcardTemplateFilter.vue?vue&type=template&id=984b6aac&"
import script from "./EcardTemplateFilter.vue?vue&type=script&lang=js&"
export * from "./EcardTemplateFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports